import {
  getDataFields,
  getCustomizationField,
  getPieChartDetails,
} from "../components/VizComponents/Pie/controlPanel";
import {
  getDataFieldsBar,
  getCustomizationFieldBar,
  getBarChartDetails,
} from "../components/VizComponents/BarChart/controlPanel";
import {
  getDataFieldsPivotTable,
  getCustomizationFieldPivotTable,
  getPivotTableChartDetails,
} from "../components/VizComponents/PivotTable/controlPanal";
import {
  getDataFieldsTable,
  getCustomizationFieldsTable,
  getTableChartDetails,
} from "../components/VizComponents/Table/controlPanel";
import {
  getDataFieldline,
  getCustomizationFieldline,
  getLineChartDetails,
} from "../components/VizComponents/Line/controlPanel";
import {
  getDataFieldsArea,
  getCustomizationFieldArea,
  getAreaChartDetails,
} from "../components/VizComponents/Area/controlPanel";

import {
  getDataFieldsScatter,
  getCustomizationFieldScatter,
  getScatterChartDetails,
} from "../components/VizComponents/Scatter/controlPanel";

import {
  getDataFieldsWordcloud,
  getCustomizationFieldWordcloud,
  getWordCloudChartDetails,
} from "../components/VizComponents/WordCloud/controlPanel";
import {
  getDataFieldsFunnelchart,
  getCustomizationFieldFunnelchart,
  getFunnelChartDetails,
} from "../components/VizComponents/Funnel/controlPanel";
import {
  getDataFieldsDiskUsageTreechart,
  getCustomizationFieldDiskUsageTreechart,
  getDiskUsageTreeChartDetails,
} from "../components/VizComponents/DiskUsageTree/controlPanel";
import {
  getDataFieldsHeatmapchart,
  getCustomizationFieldHeatmapchart,
  getHeatmapChartDetails,
} from "../components/VizComponents/Heatmap/controlPanel";
import {
  getDataFieldsSankeychart,
  getCustomizationFieldSankeychart,
  getsankeyChartDetails,
} from "../components/VizComponents/Sankey/controlPanel";

import {
  getDataFieldsstacked,
  getCustomizationFieldStacked,
  getStackedChartDetails,
} from "../components/VizComponents/Stacked/controlPanel";
import {
  getDataFieldsstackedimage,
  getCustomizationFieldStackedimage,
  getStackedImageChartDetails,
} from "../components/VizComponents/Stackedimage/controlPanel";
import {
  getDataFieldsCombochart,
  getCustomizationCombochart,
  getComboChartDetails,
} from "../components/VizComponents/Combochart/controlPanel";
import {
  getDataFieldsMapData,
  getCustomizationMapData,
  getCordinatemapChartDetails,
} from "../components/VizComponents/MapWithCordinate/controlpanel";
import ReduxPieComp from "../components/VizComponents/Pie/PieChartComp";
import BarChartComp from "../components/VizComponents/BarChart/BarChartComp";
import LineChartComp from "../components/VizComponents/Line/LineChartComp";
import AreaChartComp from "../components/VizComponents/Area/AreaChartComp";
import ScatterChartComp from "../components/VizComponents/Scatter/ScatterChartComp";

import WordCloudChartComp from "../components/VizComponents/WordCloud/WordCloudChartComp";
import FunnelChartComp from "../components/VizComponents/Funnel/FunnelChartComp";
import TreeChartComp from "../components/VizComponents/DiskUsageTree/TreeChartComp";
import HeatmapChartComp from "../components/VizComponents/Heatmap/HeatmapChartComp";
import SankeyChartComp from "../components/VizComponents/Sankey/SankeyChartComp";

import StackedBarChartComp from "../components/VizComponents/Stacked/StackedBarChartComp";
import StackedBarImageComp from "../components/VizComponents/Stackedimage/StackedBarImageComp";
import PivotTable from "../components/VizComponents/PivotTable/PiviotTable";
import { buildIntialSheetState } from "./buildInitialSheetState";
import CordinateMap from "../components/VizComponents/MapWithCordinate/CordinateMap";
import {
  getNeedlePieChartDetails,
  getNeedlePieCustomizationField,
  getNeedlePieDataFields,
} from "../components/VizComponents/PieChartWithNeedle/controlPanel";
import NeedlePieChart from "../components/VizComponents/PieChartWithNeedle/NeedlePieChart";
import Combochart from "../components/VizComponents/Combochart/Combochart";

import {
  getBigNumberDataFields,
  getBigNumberCustomizationFields,
  getBigNumberchartDetails,
} from "../components/VizComponents/BigNumber/controlPanel";

import BigNumberComp from "../components/VizComponents/BigNumber/BigNumberComp";

import {
  getRankTileDataFields,
  getRankTileCustomizationFields,
  getRankTileChartDetails,
} from "../components/VizComponents/RankTile/controlPanel";
import RankTileComp from "../components/VizComponents/RankTile/RankTileComp";
import RadarChartComp from "../components/VizComponents/Radar/RadarChartComp";
import {
  getRadarChartDetails,
  getRadarCustomizationFields,
  getRadarDataFields,
} from "../components/VizComponents/Radar/controllPanel";
import AreaMap from "../components/VizComponents/MapWithArea/AreaMap";
import {
  getAreamapChartDetails,
  getCustomizationAreaMapData,
  getDataFieldsAreaMapData,
} from "../components/VizComponents/MapWithArea/controlpanel";
import Table from "../components/VizComponents/Table/Table";

export const getAside2components = (vizType) => {
  // console.log(vizType);
  switch (vizType) {
    case "piechart": {
      const DataArrayComponents = getDataFields();
      const CustomizeArrayComponents = getCustomizationField();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "needlePie": {
      const DataArrayComponents = getNeedlePieDataFields();
      const CustomizeArrayComponents = getNeedlePieCustomizationField();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "simpleTable": {
      const DataArrayComponents = getDataFieldsPivotTable();
      const CustomizeArrayComponents = getCustomizationFieldPivotTable();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "table": {
      const DataArrayComponents = getDataFieldsTable();
      const CustomizeArrayComponents = getCustomizationFieldsTable();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "barchart": {
      const DataArrayComponents = getDataFieldsBar();
      const CustomizeArrayComponents = getCustomizationFieldBar();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "linechart": {
      const DataArrayComponents = getDataFieldline();
      const CustomizeArrayComponents = getCustomizationFieldline();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "areachart": {
      const DataArrayComponents = getDataFieldsArea();
      const CustomizeArrayComponents = getCustomizationFieldArea();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "scatterchart": {
      const DataArrayComponents = getDataFieldsScatter();
      const CustomizeArrayComponents = getCustomizationFieldScatter();
      return { DataArrayComponents, CustomizeArrayComponents };
    }

    case "wordcloudchart": {
      const DataArrayComponents = getDataFieldsWordcloud();
      const CustomizeArrayComponents = getCustomizationFieldWordcloud();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "bigNumber": {
      const DataArrayComponents = getBigNumberDataFields();
      const CustomizeArrayComponents = getBigNumberCustomizationFields();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "rankTile": {
      const DataArrayComponents = getRankTileDataFields();
      const CustomizeArrayComponents = getRankTileCustomizationFields();
      return { DataArrayComponents, CustomizeArrayComponents };
    }

    case "radarchart": {
      const DataArrayComponents = getRadarDataFields();
      const CustomizeArrayComponents = getRadarCustomizationFields();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "funnelchart": {
      const DataArrayComponents = getDataFieldsFunnelchart();
      const CustomizeArrayComponents = getCustomizationFieldFunnelchart();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "disktreechart": {
      const DataArrayComponents = getDataFieldsDiskUsageTreechart();
      const CustomizeArrayComponents =
        getCustomizationFieldDiskUsageTreechart();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "heatmapchart": {
      const DataArrayComponents = getDataFieldsHeatmapchart();
      const CustomizeArrayComponents = getCustomizationFieldHeatmapchart();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "sankeychart": {
      const DataArrayComponents = getDataFieldsSankeychart();
      const CustomizeArrayComponents = getCustomizationFieldSankeychart();
      return { DataArrayComponents, CustomizeArrayComponents };
    }

    case "stackedbarchart": {
      const DataArrayComponents = getDataFieldsstacked();
      const CustomizeArrayComponents = getCustomizationFieldStacked();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "stackedbarchartimage": {
      const DataArrayComponents = getDataFieldsstackedimage();
      const CustomizeArrayComponents = getCustomizationFieldStackedimage();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "cordinatemap": {
      const DataArrayComponents = getDataFieldsMapData();
      const CustomizeArrayComponents = getCustomizationMapData();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "areamap": {
      const DataArrayComponents = getDataFieldsAreaMapData();
      const CustomizeArrayComponents = getCustomizationAreaMapData();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "combochart": {
      const DataArrayComponents = getDataFieldsCombochart();
      const CustomizeArrayComponents = getCustomizationCombochart();
      return { DataArrayComponents, CustomizeArrayComponents };
    }

    default: {
      // it's temporary default until we set all the cases
      const DataArrayComponents = getDataFields();
      const CustomizeArrayComponents = getCustomizationField();
      return { DataArrayComponents, CustomizeArrayComponents };
      // return ([]);
    }
  }
};

export const getAside3VizComponent = (vizType) => {
  // console.log(vizType);
  switch (vizType) {
    case "piechart": {
      return (props) => <ReduxPieComp {...props} />;
    }
    case "needlePie": {
      return (props) => <NeedlePieChart {...props} />;
    }
    case "simpleTable": {
      return (props) => <PivotTable {...props} />;
    }
    case "table": {
      return (props) => <Table {...props} />;
    }
    case "barchart": {
      return (props) => <BarChartComp {...props} />;
    }
    case "linechart": {
      return (props) => <LineChartComp {...props} />;
    }
    case "areachart": {
      return (props) => <AreaChartComp {...props} />;
    }
    case "scatterchart": {
      return (props) => <ScatterChartComp {...props} />;
    }

    case "wordcloudchart": {
      return (props) => <WordCloudChartComp {...props} />;
    }
    case "bigNumber": {
      return (props) => <BigNumberComp {...props} />;
    }
    case "rankTile": {
      return (props) => <RankTileComp {...props} />;
    }

    case "radarchart": {
      return (props) => <RadarChartComp {...props} />;
    }
    case "funnelchart": {
      return (props) => <FunnelChartComp {...props} />;
    }
    case "disktreechart": {
      return (props) => <TreeChartComp {...props} />;
    }
    case "heatmapchart": {
      return (props) => <HeatmapChartComp {...props} />;
    }
    case "sankeychart": {
      return (props) => <SankeyChartComp {...props} />;
    }

    case "stackedbarchart": {
      return (props) => <StackedBarChartComp {...props} />;
    }
    case "stackedbarchartimage": {
      return (props) => <StackedBarImageComp {...props} />;
    }
    case "cordinatemap": {
      return (props) => <CordinateMap {...props} />;
    }
    case "areamap": {
      return (props) => <AreaMap {...props} />;
    }
    case "combochart": {
      return (props) => <Combochart {...props} />;
    }

    default: {
      // it's temporary default until we set all the cases
      return;
      // return ([]);
    }
  }
};

export const getDefaultReduxState = ({ vizType, dataSourceID, sheetName }) => {
  // console.log(vizType);
  switch (vizType) {
    case "piechart": {
      const DataArrayComponents = getDataFields();
      const CustomizeArrayComponents = getCustomizationField();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      // console.log(newSheetState);
      return { newSheetState };
    }
    case "needlePie": {
      const DataArrayComponents = getNeedlePieDataFields();
      const CustomizeArrayComponents = getNeedlePieCustomizationField();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      // console.log(newSheetState);
      return { newSheetState };
    }
    case "simpleTable": {
      const DataArrayComponents = getDataFieldsPivotTable();
      const CustomizeArrayComponents = getCustomizationFieldPivotTable();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }
    case "table": {
      const DataArrayComponents = getDataFieldsTable();
      const CustomizeArrayComponents = getCustomizationFieldsTable();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }
    case "barchart": {
      const DataArrayComponents = getDataFieldsBar();
      const CustomizeArrayComponents = getCustomizationFieldBar();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }
    case "linechart": {
      const DataArrayComponents = getDataFieldline();
      const CustomizeArrayComponents = getCustomizationFieldline();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }
    case "areachart": {
      const DataArrayComponents = getDataFieldsArea();
      const CustomizeArrayComponents = getCustomizationFieldArea();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }
    case "scatterchart": {
      const DataArrayComponents = getDataFieldsScatter();
      const CustomizeArrayComponents = getCustomizationFieldScatter();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }

    case "wordcloud": {
      const DataArrayComponents = getDataFieldsWordcloud();
      const CustomizeArrayComponents = getCustomizationFieldWordcloud();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }
    case "bigNumber": {
      const DataArrayComponents = getBigNumberDataFields();
      const CustomizeArrayComponents = getBigNumberCustomizationFields();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      // // console.log(newSheetState);
      return { newSheetState };
    }
    case "rankTile": {
      const DataArrayComponents = getRankTileDataFields();
      const CustomizeArrayComponents = getRankTileCustomizationFields();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      // // console.log(newSheetState);
      return { newSheetState };
    }
    case "radarchart": {
      const DataArrayComponents = getRadarDataFields();
      const CustomizeArrayComponents = getRadarCustomizationFields();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      // // console.log(newSheetState);
      return { newSheetState };
    }
    case "funnelchart": {
      const DataArrayComponents = getDataFieldsFunnelchart();
      const CustomizeArrayComponents = getCustomizationFieldFunnelchart();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }
    case "disktreechart": {
      const DataArrayComponents = getDataFieldsDiskUsageTreechart();
      const CustomizeArrayComponents =
        getCustomizationFieldDiskUsageTreechart();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }
    case "sankeychart": {
      const DataArrayComponents = getDataFieldsSankeychart();
      const CustomizeArrayComponents = getCustomizationFieldSankeychart();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }

    case "heatmapchart": {
      const DataArrayComponents = getDataFieldsHeatmapchart();
      const CustomizeArrayComponents = getCustomizationFieldHeatmapchart();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }
    case "stackedbarchart": {
      const DataArrayComponents = getDataFieldsstacked();
      const CustomizeArrayComponents = getCustomizationFieldStacked();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }
    case "stackedbarchartimage": {
      const DataArrayComponents = getDataFieldsstackedimage();
      const CustomizeArrayComponents = getCustomizationFieldStackedimage();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }
    case "cordinatemap": {
      const DataArrayComponents = getDataFieldsMapData();
      const CustomizeArrayComponents = getCustomizationMapData();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }
    case "areamap": {
      const DataArrayComponents = getDataFieldsAreaMapData();
      const CustomizeArrayComponents = getCustomizationAreaMapData();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }
    case "combochart": {
      const DataArrayComponents = getDataFieldsCombochart();
      const CustomizeArrayComponents = getCustomizationCombochart();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }
    default: {
      const DataArrayComponents = getDataFields();
      const CustomizeArrayComponents = getCustomizationField();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }
  }
};

export const getChartDetails = (vizType) => {
  // console.log(vizType);
  switch (vizType) {
    case "piechart": {
      const chartDetials = getPieChartDetails();
      return chartDetials;
    }
    case "needlePie": {
      const chartDetials = getNeedlePieChartDetails();
      return chartDetials;
    }
    case "simpleTable": {
      const chartDetials = getPivotTableChartDetails();
      return chartDetials;
    }
    case "table": {
      const chartDetials = getTableChartDetails();
      return chartDetials;
    }
    case "barchart": {
      const chartDetials = getBarChartDetails();
      return chartDetials;
    }
    case "linechart": {
      const chartDetials = getLineChartDetails();
      return chartDetials;
    }
    case "areachart": {
      const chartDetials = getAreaChartDetails();
      return chartDetials;
    }
    case "scatterchart": {
      const chartDetials = getScatterChartDetails();
      return chartDetials;
    }

    case "wordcloudchart": {
      const chartDetials = getWordCloudChartDetails();
      return chartDetials;
    }
    case "bigNumber": {
      const chartDetials = getBigNumberchartDetails();
      return chartDetials;
    }
    case "rankTile": {
      const chartDetials = getRankTileChartDetails();
      return chartDetials;
    }

    case "radarchart": {
      const chartDetials = getRadarChartDetails();
      return chartDetials;
    }
    case "funnelchart": {
      const chartDetials = getFunnelChartDetails();
      return chartDetials;
    }
    case "disktreechart": {
      const chartDetials = getDiskUsageTreeChartDetails();
      return chartDetials;
    }
    case "heatmapchart": {
      const chartDetials = getHeatmapChartDetails();
      return chartDetials;
    }
    case "sankeychart": {
      const chartDetials = getsankeyChartDetails();
      return chartDetials;
    }

    case "stackedbarchart": {
      const chartDetials = getStackedChartDetails();
      return chartDetials;
    }
    case "stackedbarchartimage": {
      const chartDetials = getStackedImageChartDetails();
      return chartDetials;
    }
    case "cordinatemap": {
      const chartDetials = getCordinatemapChartDetails();
      return chartDetials;
    }
    case "areamap": {
      const chartDetials = getAreamapChartDetails();
      return chartDetials;
    }
    case "combochart": {
      const chartDetials = getComboChartDetails();
      return chartDetials;
    }
    default: {
      return { chartType: "recharts" };
    }
  }
};

export const getVizStyleArray = () => {
  return [
    {
      iconSrc: "/graph_img/PivotTable.png",
      label: "Pivot Table",
      value: "simpleTable",
    },
    {
      iconSrc: "/graph_img/Table.png",
      label: "Table",
      value: "table",
    },
    {
      iconSrc: "/graph_img/Piechart.png",
      label: "Pie",
      value: "piechart",
    },
    {
      iconSrc: "/graph_img/Linechart.png",
      label: "Line",
      value: "linechart",
    },
    {
      iconSrc: "/graph_img/Areachart.png",
      label: "Area",
      value: "areachart",
    },
    {
      iconSrc: "/graph_img/Stackbarchart.png",
      label: "Bar",
      value: "stackedbarchart",
    },
    {
      iconSrc: "/graph_img/Bubblechart.png",
      label: "Scatter",
      value: "scatterchart",
    },

    {
      iconSrc: "/graph_img/wordcloud.png",
      label: "WordCloud",
      value: "wordcloudchart",
    },
    {
      iconSrc: "/graph_img/radar.png",
      label: "Radar",
      value: "radarchart",
    },
    {
      iconSrc: "/graph_img/funnelchart.png",
      label: "Funnel",
      value: "funnelchart",
    },
    {
      iconSrc: "/graph_img/Treechart.png",
      label: "Tree",
      value: "disktreechart",
    },
    {
      iconSrc: "/graph_img/heatmap.png",
      label: "Heatmap",
      value: "heatmapchart",
    },
    {
      iconSrc: "/graph_img/sankey.png",
      label: "Sankey",
      value: "sankeychart",
    },
    {
      iconSrc: "/graph_img/Treechart.png",
      label: "MapChart",
      value: "mapchart",
    },
    {
      iconSrc: "/graph_img/combochart.png",
      label: "Combo",
      value: "combochart",
    },
    {
      iconSrc: "/graph_img/bignumber.png",
      label: "BigNumber",
      value: "bigNumber",
    },
    {
      iconSrc: "/graph_img/Stackbarchart.png",
      label: "BarWithImage",
      value: "stackedbarchartimage",
    },
    {
      iconSrc: "/graph_img/bignumber.png",
      label: "RankTile",
      value: "rankTile",
    },
    {
      iconSrc: "/graph_img/Mapchart.png",
      label: "PointsMap",
      value: "cordinatemap",
    },
    {
      iconSrc: "/graph_img/Mapchart.png",
      label: "AreaMap",
      value: "areamap",
    },
  ];
};
